/**
 * deleteRole — RPC contract for the deleteRole callable.
 *
 * `role.entity.ts` marks `delete` `.requiresHandler('deleteRole')`.
 * `deleteRole.api.ts` (onCall): caller holds `tickets.roles.manage` → target
 * role exists AND is not built-in → the target role's own permissions ⊆
 * caller's own role's permissions (a caller cannot delete a role reaching
 * further than their own) → no active member currently references the role
 * (the FE-only guard `members.api.ts` carried — `role-form.view.ts`'s
 * member-count check — moves server-side as a byproduct of this write path no
 * longer being a bare `deleteDoc`) → delete.
 *
 * Fields justified:
 *   roleId — the role being deleted.
 */
import { z } from "zod";
import { Id } from "./workspace.entity.ts";

export const DeleteRoleInput = z.object({ orgId: Id, roleId: Id }).strict();
export type DeleteRoleInput = z.infer<typeof DeleteRoleInput>;

export const DeleteRoleOutput = z.object({ ok: z.literal(true) }).strict();
export type DeleteRoleOutput = z.infer<typeof DeleteRoleOutput>;
